import 'pace-js';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AgmCoreModule } from '@agm/core';

import { routing } from './app.routing';
import { AppConfig } from './app.config';

import { AppComponent } from './app.component';
import { ErrorComponent } from './trilce/error/error.component';
import { AuthGuardService } from './support/services/auth-guard.service';
import { AuthenticationService } from './support/services/authentication.service';
import { StorageService } from './support/services/storage.service';
import { UserService } from './support/services/user.service';
import { HttpService } from './support/services/http.service';
import { Router } from '@angular/router';

import { HttpModule, RequestOptions, XHRBackend } from '@angular/http';


@NgModule({
  declarations: [
    AppComponent,
    ErrorComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDe_oVpi9eRSN99G4o6TwVjJbFBNr58NxE'
    }),
    routing,
    HttpModule
  ],
  providers: [
    AppConfig,
    AuthGuardService,
    AuthenticationService,
    StorageService,
    UserService,
    {
      provide: HttpService,
      useFactory: httpFactory,
      deps: [XHRBackend, RequestOptions, Router]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function httpFactory(backend: XHRBackend, options: RequestOptions, router: Router) {
  return new HttpService(backend, options, router);
}


// WEBPACK FOOTER //
// C:/Users/egila/Downloads/temp/20260608_NuevoSAT/Trilce.Presentacion.Intranet.Profesores.NG5/src/app/app.module.ts